import { gql } from '@apollo/client';

export const capTableReportGenerate = gql`
  mutation capTableReportGenerate(
    $investmentId: UUID!, $email: String!, $asOfDate: Date!
  ) {
    capTableReportGenerate(investmentId: $investmentId, email: $email, asOfDate: $asOfDate) {
      success
    }
  }
`;
